import { FileDown } from "lucide-react";
import { toast } from "sonner";

export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export default function OrderFormButton({ client, path, testid }) {
  const download = async () => {
    try {
      const res = await client.get(path, { responseType: "blob" });
      downloadBlob(res.data, "bon-de-commande-petales-de-miel.pdf");
    } catch {
      toast.error("Génération du bon de commande impossible");
    }
  };
  return (
    <button data-testid={testid} onClick={download} className="flex items-center gap-2 rounded-full border border-amber-800/25 bg-white px-4 py-2 text-sm font-medium text-bark transition-colors hover:border-amber-deep hover:text-amber-deep">
      <FileDown size={15} /> Bon de commande (PDF)
    </button>
  );
}
